import { ScrollRestoration } from 'shared/components/utils';

import { ContentWrapper } from './components';

import type { FC, PropsWithChildren as ContentProps } from 'react';

export const CONTENT_TEST_ID = 'content';

export const Content: FC<ContentProps> = ({ children }) => (
  <ScrollRestoration>
    <ContentWrapper data-testid={CONTENT_TEST_ID}>{children}</ContentWrapper>
  </ScrollRestoration>
);
